import { render, staticRenderFns } from "./BreadcrumpsSection.vue?vue&type=template&id=07ea3deb&"
import script from "./BreadcrumpsSection.vue?vue&type=script&lang=js&"
export * from "./BreadcrumpsSection.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumpsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports